const storageLocales = {
    TCtoken: '@TC-x-token',
    TCAuthOperator: '@TCAuthOperator:user_id',
    TCUser: '@TCUser',
}

export default storageLocales;